import "./App.css";
import UploadImg from "./components/UploadImg";

function App() {
  return (
    <div className="App">
      <UploadImg />
    </div>
  );
}

export default App;
